<template>
  <el-drawer
    :visible.sync="isDisplay"
    size="95%"
    direction="btt">
    <iframe src="/static/files/最新跨境人民币收款分发线上客户服务协议.pdf" frameborder="0"
            scrolling="none"
            style="width: 100%; height: 100%;margin-bottom: 100px;">
    </iframe>
    <div class="agreement-bottom">
      <el-button @click="isDisplay=false">{{ $t('message.tableCommon.cancel') }}</el-button>
      <el-button @click="onAgree" type="primary">{{ $t('message.common.agree') }}</el-button>
    </div>
  </el-drawer>
</template>

<script>

export default {
  name: 'CustomerAgreement',
  data() {
    return {
      isDisplay: false,
    };
  },
  methods: {
    async open() {
      this.isDisplay = true;
    },
    onAgree() {
      this.$emit('onAgreeClick');
      this.isDisplay = false;
    },
  },
};
</script>

<style scoped>
.agreement-bottom {
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 100px;
  line-height: 90px;
  text-align: center;
  box-shadow: 0px -2px 4px 0px rgba(146, 146, 146, 0.5);
  z-index: 100;
  background: #FFF;
}
</style>
